import { bookingPeriodDates, bookingPeriodDays } from './booking-period'
import { trackEvent } from './track-event'

type Action = 'booking period' | 'alternative date'

export function trackCtaPeriod(
  from: Date | null | undefined,
  to: Date | null | undefined,
  type: 'experience' | 'accommodation' | 'beach_chair' | 'rentable',
  action: Action = 'booking period'
) {
  if (!from || !to) return

  trackEvent({
    event: 'click_cta_period',
    event_name: 'user_interaction',
    action: `click - take over - ${action}`,
    ...bookingPeriodDates(from, to),
    ...bookingPeriodDays(from, to),
    type,
  })
}
